import baseStyled, { css as _css, ThemeContext as _ThemeContext, } from 'styled-components';
const styled = baseStyled;
export const css = _css;
export const ThemeContext = _ThemeContext;
export default styled;
//# sourceMappingURL=index.js.map